import { useEffect, useState } from "react";
import { meetActionTypes } from "../../../base/action/action";
import { getToken } from "../../../base/utils";
import { AntInput } from "../../../shared/widges/antinput";
import store from "../../../store/redux-store/root_store";
import moment from "moment";

export default function MeetTranscription() {

  const { oriTranscript } = store.getState().closeCaption;
  const [scroll,setScroll]=useState(false)
  const [transcript,setTranscript]=useState(oriTranscript);
  const [search,setSearch]=useState("");
  const closeTrans =() =>{
    let getCookie: any = getToken();
    if( getCookie["ssoToken"]){
      store.dispatch({
        type:meetActionTypes.MEETING_CONTROL_OPEN,
        payload:{
          componentState:"internalChat"
        }
        
        })
    }
    
    
    if(getCookie["guestToken"]){
    
      store.dispatch({
        type:meetActionTypes.CUSTOMER_CONTROL_OPEN,
        payload:{
          customerComponentState:""
        }
        
        })
    }
    
    
    }

    const Scroll=(e:any)=>{
      const container = document.getElementById('rawtranscript');
      if(container){        
        if(((Math.round(container.scrollTop+ container.clientHeight)) === container.scrollHeight)|| ((Math.round(container.scrollTop+ container.clientHeight)+1) === container.scrollHeight)){
        setScroll(false);
      }
       if((Math.round(container.scrollTop+ container.clientHeight)+1) < container.scrollHeight){
        setScroll(true);
      }
    }
  }

    useEffect(()=>{    
  if(!scroll){
    requestAnimationFrame(() => {
    const container = document.getElementById('rawtranscript');
    if(container){container.scrollTop = container.scrollHeight;}
  });}
    },[oriTranscript.length,scroll,search,oriTranscript[oriTranscript?.length-1]?.finalText?.length])
    const scrollToBottom=()=>{
        setScroll(false);
  }

  const handleOnSearch = (e: any) => {
    if(e.target.value !== ""){ let output = oriTranscript.filter(function (obj: any) {
     return (obj.finalText.toLowerCase()).includes(e.target.value.toLowerCase());
   });
   setSearch(e.target.value);
     setTranscript(output);
   }
     else{
       setSearch("")
       setTranscript(oriTranscript);
     }
   };
  return (
    <>
      <div className="chatwidgetcustomer">
        <div className="chatwidgettop topnew">
          <h3>Transcription</h3>
          <div className="closebtn" onClick={closeTrans}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M9.20122 7.54398L15.0562 1.68848C15.3882 1.35738 15.3882 0.818381 15.0562 0.487281C14.7242 0.155281 14.1851 0.155281 13.855 0.487281L8.00002 6.34268L2.14502 0.487281C1.81492 0.155281 1.27392 0.155281 0.943824 0.487281C0.611824 0.818381 0.611824 1.35738 0.943824 1.68848L6.79882 7.54398L0.943824 13.3995C0.611824 13.7306 0.611824 14.2696 0.943824 14.6007C1.10982 14.7667 1.32662 14.8497 1.54442 14.8497C1.76222 14.8497 1.97992 14.7667 2.14502 14.6007L8.00002 8.74528L13.855 14.6007C14.02 14.7667 14.2378 14.8497 14.4556 14.8497C14.6734 14.8497 14.8902 14.7667 15.0562 14.6007C15.3882 14.2696 15.3882 13.7306 15.0562 13.3995L9.20122 7.54398Z" fill="#757676" />
            </svg>
          </div>
        </div>


        {/* <div className="searchboxtranscripts">
          <AntInput className="tableSearch" placeHolder="Search" onChange={handleOnSearch} />
        </div> */}
        <div className="chatwidgetmiddle scroller transcripts"  onScroll={Scroll}  id="rawtranscript">

          <div className="chatwidgetmiddleinner">

          {transcript.length && transcript.map((elem: any, index: any) => {
          return(
                      <div className="leftchat" key={index}>
                        <div className="msgtop">
                          <h3><span>{elem?.speakerName?.toUpperCase().slice(0, 2)}</span>{elem.speakerName}</h3>
                          <p className="timers">{moment(elem.timeStamp).format('hh:mm a')}</p>
                        </div>
                        <div className="msgcontent">
                          <p>{elem?.finalText}</p>
                        </div>
                      </div>)
          })
          }
                  {transcript.length === 0 && search === ""  && <div>
                      <object  type="image/svg+xml">Loading...</object>
                    </div>}
               {transcript.length === 0 && search !== "" && <span
              >No Data Found</span>}
          </div>
        </div>

        { scroll  && <div onClick={scrollToBottom}>
                <svg width="68" height="69" viewBox="0 0 68 69" fill="none" xmlns="http://www.w3.org/2000/svg" className="svgbottomarrow">
                  <g filter="url(#filter0_dd_2803_57024)">
                    <rect x="12" y="2.54297" width="44" height="44" rx="22" fill="#C4F5E8" />
                    <g clip-path="url(#clip0_2803_57024)">
                      <path d="M39.8602 27.0605C39.5672 26.7675 39.0926 26.7675 38.7997 27.0605L34.7499 31.1103V16.7812C34.7499 16.3672 34.414 16.0312 33.9999 16.0312C33.5858 16.0312 33.2499 16.3672 33.2499 16.7812V31.1108L29.2001 27.0605C28.9071 26.7675 28.4325 26.7675 28.1396 27.0605C27.8467 27.3535 27.8466 27.8281 28.1396 28.121L32.4096 32.3916C32.8368 32.8183 33.4023 33.0536 34.0034 33.0536H34.0137C34.6133 33.0508 35.1748 32.8144 35.5899 32.3916L39.8604 28.121C40.1534 27.828 40.1532 27.3534 39.8602 27.0605Z" fill="black" />
                    </g>
                  </g>
                  <defs>
                    <filter id="filter0_dd_2803_57024" x="0" y="0.542969" width="68" height="68" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2803_57024" />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="3" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2803_57024" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feMorphology radius="3" operator="erode" in="SourceAlpha" result="effect2_dropShadow_2803_57024" />
                      <feOffset dy="10" />
                      <feGaussianBlur stdDeviation="7.5" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                      <feBlend mode="normal" in2="effect1_dropShadow_2803_57024" result="effect2_dropShadow_2803_57024" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2803_57024" result="shape" />
                    </filter>
                    <clipPath id="clip0_2803_57024">
                      <rect width="24" height="24" fill="white" transform="translate(22 12.543)" />
                    </clipPath>
                  </defs>
                </svg>
                </div>}

      </div>
    </>
  )

}